import styled from 'styled-components';
import { Card, Badge, Modal } from 'react-bootstrap';

export const PageContainer = styled.div`
  padding: 2rem 1rem;
  max-width: 1400px;
  margin: 0 auto;
`;

export const HeaderSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #e0e7ff 0%, #c3d4fe 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3b82f6;
  font-size: 1.5rem;
  box-shadow: 0 4px 6px rgba(59, 130, 246, 0.1);
`;

export const PageTitle = styled.h2`
  margin: 0;
  font-weight: 700;
  color: #1e293b;
  font-size: 1.75rem;
  letter-spacing: -0.5px;
`;

export const PageSubtitle = styled.p`
  margin: 4px 0 0 0;
  color: #64748b;
  font-size: 0.95rem;
`;

export const StyledCard = styled(Card)`
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.02);
  overflow: hidden;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  }
`;

export const CardHeader = styled.div`
  padding: 1.5rem 2rem;
  background: linear-gradient(to right, #f8fafc, #ffffff);
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled.h5`
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  font-size: 1.1rem;
`;

export const SectionTitle = styled.h6`
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 1.25rem 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 20px;
    background: #3b82f6;
    border-radius: 4px;
    flex-shrink: 0;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const InfoCard = styled.div`
  background: #f8fafc;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  border: 1px solid #e2e8f0;

  .label {
    color: #64748b;
    font-size: 0.8rem;
    font-weight: 600;
    margin-bottom: 4px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  .value {
    color: #0f172a;
    font-weight: 700;
    font-size: 1.05rem;
  }
`;

export const ServiceGroupCard = styled.div`
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #cbd5e1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }
`;

export const GroupHeader = styled.div`
  background: #f8fafc;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s ease;

  &:hover {
    background: #f1f5f9;
  }

  .group-label {
    font-weight: 700;
    color: #334155;
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .group-amount {
    color: #475569;
    font-weight: 600;
    font-size: 0.95rem;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .expand-icon {
    color: #94a3b8;
    font-size: 0.85rem;
    transition: transform 0.2s ease;
  }

  .expand-icon.expanded {
    transform: rotate(180deg);
  }
`;

export const TierTable = styled.table`
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  font-size: 0.875rem;

  th {
    background: #f1f5f9;
    color: #475569;
    font-weight: 600;
    padding: 0.75rem 1rem;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
    font-size: 0.8rem;
  }

  td {
    color: #334155;
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover td {
    background: #f8fafc;
  }

  tfoot th {
    background: #f8fafc;
    border-top: 2px solid #e2e8f0;
    border-bottom: none;
  }
`;

export const CompensationBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border: 1px solid #fef08a;
  border-radius: 6px;
  background: #fefce8;
  box-shadow: 0 1px 2px rgba(234, 179, 8, 0.1);
  font-size: 0.8rem;

  .comp-label {
    color: #ca8a04;
    font-weight: 600;
  }

  .comp-value {
    color: #854d0e;
    font-weight: 700;
  }
`;

export const StatusBadge = styled(Badge)`
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 0.75rem;
  letter-spacing: 0.2px;

  &.status-confirmed {
    background-color: #dcfce7 !important;
    color: #16a34a !important;
    border: 1px solid #bbf7d0;
  }

  &.status-pending {
    background-color: #fef3c7 !important;
    color: #d97706 !important;
    border: 1px solid #fde68a;
  }

  &.status-interim {
    background-color: #dbeafe !important;
    color: #2563eb !important;
    border: 1px solid #bfdbfe;
  }

  &.status-applied {
    background-color: #e0f2fe !important;
    color: #0284c7 !important;
    border: 1px solid #bae6fd;
  }

  &.status-not-applied {
    background-color: #f1f5f9 !important;
    color: #94a3b8 !important;
    border: 1px solid #e2e8f0;
  }
`;

export const TotalSummaryCard = styled.div`
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-top: 1rem;

  .summary-title {
    color: #1e40af;
    font-weight: 700;
    font-size: 0.9rem;
    margin-bottom: 0.5rem;
  }

  .summary-amount {
    color: #1d4ed8;
    font-weight: 800;
    font-size: 1.35rem;
  }

  .summary-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.35rem 0;
    color: #334155;
    font-size: 0.9rem;
  }

  .summary-row.highlight {
    color: #1e40af;
    font-weight: 700;
    font-size: 1rem;
    padding-top: 0.75rem;
    margin-top: 0.5rem;
    border-top: 2px solid #93c5fd;
  }
`;

export const ActionButton = styled.button`
  border-radius: 8px;
  font-weight: 600;
  padding: 0.6rem 1.2rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  width: 100%;

  &.btn-primary-action {
    background: #3b82f6;
    color: #ffffff;
    box-shadow: 0 2px 4px rgba(59, 130, 246, 0.2);

    &:hover {
      background: #2563eb;
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
    }
  }

  &.btn-outline-action {
    background: #ffffff;
    color: #3b82f6;
    border: 1px solid #3b82f6;
    box-shadow: 0 1px 3px rgba(59, 130, 246, 0.1);

    &:hover {
      background: #eff6ff;
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(59, 130, 246, 0.15);
    }
  }

  &.btn-info-action {
    background: linear-gradient(135deg, #06b6d4, #0891b2);
    color: #ffffff;
    box-shadow: 0 2px 4px rgba(6, 182, 212, 0.2);

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 8px rgba(6, 182, 212, 0.3);
    }
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }
`;

export const SegmentedControl = styled.div`
  display: inline-flex;
  background: #f1f5f9;
  border-radius: 10px;
  padding: 3px;
  gap: 2px;

  .segment-btn {
    padding: 6px 16px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.2s ease;
    background: transparent;
    color: #64748b;

    &:hover {
      color: #334155;
    }

    &.active {
      background: #ffffff;
      color: #3b82f6;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    }
  }
`;

export const MonthSelector = styled.select`
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font-weight: 600;
  color: #334155;
  padding: 0.5rem 2rem 0.5rem 0.75rem;
  font-size: 0.9rem;
  width: 100%;
  appearance: auto;
  cursor: pointer;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
    background: #ffffff;
  }
`;

export const ProgressBarWrapper = styled.div`
  background: #f1f5f9;
  border-radius: 12px;
  height: 36px;
  overflow: hidden;
  position: relative;
  margin-top: 0.5rem;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #3b82f6, #60a5fa);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: width 0.6s cubic-bezier(0.4, 0, 0.2, 1);
    min-width: 48px;
  }

  .progress-label {
    color: #ffffff;
    font-weight: 700;
    font-size: 0.8rem;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
  }
`;

export const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 16px;
    border: none;
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.12);
    overflow: hidden;
  }

  .modal-header {
    background: linear-gradient(to right, #f8fafc, #ffffff);
    border-bottom: 1px solid #e2e8f0;
    padding: 1.25rem 1.75rem;
  }

  .modal-title {
    font-weight: 700;
    color: #1e293b;
    font-size: 1.15rem;
  }

  .modal-body {
    padding: 1.75rem;
  }

  .modal-footer {
    background: #f8fafc;
    border-top: 1px solid #e2e8f0;
    padding: 1rem 1.75rem;
    gap: 0.5rem;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #94a3b8;
  font-size: 0.9rem;
  min-height: 4rem;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;

  .label {
    color: #475569;
    font-size: 0.9rem;
    font-weight: 500;
  }

  .value {
    color: #334155;
    font-weight: 600;
    font-size: 0.95rem;
  }

  &.discount .value {
    color: #10b981;
  }

  &.compensation .value {
    color: #0891b2;
  }

  &.divider {
    border-top: 1px solid #e2e8f0;
    margin-top: 0.5rem;
    padding-top: 0.75rem;
  }
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  color: #64748b;
  font-size: 0.95rem;
  gap: 0.75rem;
`;

export const ErrorAlert = styled.div`
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  color: #991b1b;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const PolicyInfoSection = styled.div`
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: 12px;
  padding: 1.25rem 1.5rem;
  margin-bottom: 1.5rem;
`;

export const PolicyBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  background: #dbeafe;
  color: #1e40af;
  border-radius: 6px;
  font-weight: 700;
  font-size: 0.9rem;
  border: 1px solid #bfdbfe;
`;

export const VersionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 3px 9px;
  background: #eef2ff;
  color: #4338ca;
  border: 1px solid #c7d2fe;
  border-radius: 4px;
  font-size: 0.75rem;
  font-weight: 700;
  margin-left: 6px;
  letter-spacing: 0.3px;
`;

export const ItemSection = styled.div`
  padding: 1rem 1.5rem;
  border-bottom: 1px dashed #e2e8f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const AccordionHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border: 1px solid #bae6fd;
  border-radius: ${({ $expanded }) => ($expanded ? '12px 12px 0 0' : '12px')};
  border-bottom: ${({ $expanded }) => ($expanded ? 'none' : '1px solid #bae6fd')};
  padding: 0.85rem 1.25rem;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s ease;
  text-align: left;
  font-family: inherit;

  &:hover {
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  }

  /* 마우스 클릭 시는 포커스 링 표시하지 않음 (키보드 탭 사용자만 표시) */
  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(14, 165, 233, 0.2);
  }

  .accordion-main {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
    flex-wrap: wrap;
    min-width: 0;
  }

  .accordion-icon {
    color: #1e40af;
    font-size: 0.9rem;
    transition: transform 0.2s ease;
    flex-shrink: 0;
  }

  .accordion-icon.expanded {
    transform: rotate(180deg);
  }
`;

export const AccordionBody = styled.div`
  background: #ffffff;
  border: 1px solid #bae6fd;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 1.25rem 1.5rem;
`;
